import { render } from "./AgencyThisWeekTabCont.vue?vue&type=template&id=58e4226e"
import script from "./AgencyThisWeekTabCont.vue?vue&type=script&lang=js"
export * from "./AgencyThisWeekTabCont.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__